import React from "react";

import Fancybox from "../../../../main-page-blocks/fancybox";
import LandingArrowIcon from "../../ui/LandingArrowIcon";

function PlayIcon() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M8.75 6.75L17.25 12L8.75 17.25V6.75Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default function CapabilitiesVideo({
    t,
}) {
    return (
        <Fancybox
            options={{
                mainClass:
                    "landing-video-fancybox",
                dragToClose: false,
                placeFocusBack: true,
                showClass: "f-fadeIn",
                hideClass: "f-fadeOut",
                l10n: {
                    CLOSE: t(
                        "main.landing.capabilities.video.close"
                    ),
                    MODAL: t(
                        "main.landing.capabilities.video.modal"
                    ),
                },
                Carousel: {
                    infinite: false,
                },
                Toolbar: {
                    display: {
                        left: [],
                        middle: [],
                        right: [
                            "close",
                        ],
                    },
                },
            }}
        >
            <a
                className="capabilities-video"
                href="https://vk.ru/video_ext.php?oid=-232452480&id=456239134&autoplay=1&muted=0"
                data-fancybox
                data-type="iframe"
                data-width="1200"
                data-height="675"
                aria-label={t(
                    "main.landing.capabilities.video.ariaLabel"
                )}
            >
                <div className="capabilities-video__background"/>

                <span className="capabilities-video__play">
                    <PlayIcon/>
                </span>

                <span className="capabilities-video__content">
                    <span className="capabilities-video__eyebrow">
                        {t(
                            "main.landing.capabilities.video.eyebrow"
                        )}
                    </span>

                    <strong>
                        {t(
                            "main.landing.capabilities.video.title"
                        )}
                    </strong>

                    <span>
                        {t(
                            "main.landing.capabilities.video.description"
                        )}
                    </span>
                </span>

                <span className="capabilities-video__tags">
                    <span>
                        {t(
                            "main.landing.capabilities.video.tags.deliveries"
                        )}
                    </span>

                    <span>
                        {t(
                            "main.landing.capabilities.video.tags.documents"
                        )}
                    </span>

                    <span>
                        {t(
                            "main.landing.capabilities.video.tags.control"
                        )}
                    </span>
                </span>

                <span className="capabilities-video__action">
                    {t(
                        "main.landing.capabilities.video.action"
                    )}

                    <LandingArrowIcon/>
                </span>
            </a>
        </Fancybox>
    );
}
